export const ONE_CLICK_PROFILE_CONSTANTS = {
  orderName: `Cement Bag Online Order`,
  orderTypeId: 452,
  orderTypeCode: 'ONC',
  orderTypeCodeDft: 'DFT',
  orderTypeDesc: 'Sale Order Code',
  commercialChannelCode: 'ONC',
  itemSeqNum: 10,
  currencyCode: 'MXN',
};
